import React, { useEffect, useState } from 'react';
import { Button } from '@wordpress/components';
import { __experimentalInputControl as InputControl } from '@wordpress/components';
import Fetch from './fetch.js';

function FontControl(props) {

    const id = props.idx
    const [font, setFont] = useState(props.font)
    const handleChange = ( font ) => props.handleFontChange({idx:id,fontFamily:font});

    return (
        <div className="wp-picker-container">
           <InputControl
                label="Font Family"
                        className="font-family" 
                        name="fontFamily"
                        data-index={props.idx}
                        type="text" 
                        placeholder={font} 
                        data-default-font={font}
                        value={font ?? props.font}
                        onChange={ ( newFont ) => {
                            setFont( newFont ?? props.font )
                            handleChange( newFont )
                         }}
            />
        </div>
    );

}
export default FontControl